import { InsuranceType } from '@Framework/constants/InsuranceType';
import { createStore } from '@Framework/createStore';
import { StateCreator } from 'zustand';

type SelectionStep = {
  treatment?: boolean;
  insurance?: boolean;
  provider?: boolean;
};

export type PrescriptionStore = {
  prescriptionType?: InsuranceType;
  indication?: string;
  stepInProgress?: SelectionStep;
  indicationPrice?: number;
  setPrescriptionType: (p: InsuranceType) => void;
  setIndication: (x: string) => void;
  setStepInProgress: (step: SelectionStep) => void;
  setIndicationPrice: (price: number) => void;
};

const prescriptionStore: StateCreator<PrescriptionStore> = set => ({
  setPrescriptionType: (prescriptionType: InsuranceType) => set(() => ({ prescriptionType })),
  setIndication: indication => set(() => ({ indication })),
  setStepInProgress: (stepInProgress: SelectionStep) => set(() => ({ stepInProgress })),
  setIndicationPrice: indicationPrice => set(() => ({ indicationPrice }))
});

export const usePrescriptionStore = createStore(prescriptionStore, 'PrescriptionStore');
